/* ── Bundles & Sets ──────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var data     = (window.BS && window.BS.bundles) || [];
  var filtered = [];
  var activeType     = 'all';
  var activeCategory = 'all';
  var activeVendor   = '';
  var searchVal      = '';
  var sortVal        = 'az';
  var pillsBuilt     = false;

  /* ── DOM refs ── */
  var gridEl      = document.getElementById('bs-grid');
  var emptyEl     = document.getElementById('bs-empty');
  var countEl     = document.getElementById('bs-count');
  var searchEl    = document.getElementById('bs-search');
  var sortEl      = document.getElementById('bs-sort');
  var publisherEl = document.getElementById('bs-publisher');

  /* ── Init ── */
  function init() {
    buildFilterControls();
    applyFilters();
    render();

    document.getElementById('bs-type-pills').addEventListener('click', function (e) {
      var pill = e.target.closest('.bs-pill');
      if (!pill) return;
      document.querySelectorAll('#bs-type-pills .bs-pill').forEach(function (p) {
        p.classList.remove('bs-pill--active');
      });
      pill.classList.add('bs-pill--active');
      activeType = pill.dataset.type || 'all';
      applyFilters();
      render();
    });

    document.getElementById('bs-category-pills').addEventListener('click', function (e) {
      var pill = e.target.closest('.bs-pill');
      if (!pill) return;
      document.querySelectorAll('#bs-category-pills .bs-pill').forEach(function (p) {
        p.classList.remove('bs-pill--active');
      });
      pill.classList.add('bs-pill--active');
      activeCategory = pill.dataset.category || 'all';
      applyFilters();
      render();
    });

    publisherEl.addEventListener('change', function () {
      activeVendor = publisherEl.value;
      applyFilters();
      render();
    });

    searchEl.addEventListener('input', function () {
      searchVal = searchEl.value.trim().toLowerCase();
      applyFilters();
      render();
    });

    sortEl.addEventListener('change', function () {
      sortVal = sortEl.value;
      applyFilters();
      render();
    });
  }

  /* ── Build dynamic category pills and publisher options (called once) ── */
  function buildFilterControls() {
    if (pillsBuilt) return;
    pillsBuilt = true;

    /* Deduplicated category list */
    var categories = [];
    data.forEach(function (b) {
      var cat = b.category && b.category.trim();
      if (cat && categories.indexOf(cat) === -1) {
        categories.push(cat);
      }
    });
    categories.sort(function (a, b) { return a.localeCompare(b); });

    activeCategory = 'all';
    var catContainer = document.getElementById('bs-category-pills');
    catContainer.innerHTML = '';

    var allPill = document.createElement('button');
    allPill.className = 'bs-pill bs-pill--active';
    allPill.dataset.category = 'all';
    allPill.textContent = 'All';
    catContainer.appendChild(allPill);

    categories.forEach(function (cat) {
      var pill = document.createElement('button');
      pill.className = 'bs-pill';
      pill.dataset.category = cat;
      pill.textContent = cat;
      catContainer.appendChild(pill);
    });

    /* Deduplicated vendor list */
    var vendors = [];
    data.forEach(function (b) {
      var v = b.vendor && b.vendor.trim();
      if (v && vendors.indexOf(v) === -1) {
        vendors.push(v);
      }
    });
    vendors.sort(function (a, b) { return a.localeCompare(b); });

    activeVendor = '';
    publisherEl.innerHTML = '';
    var allOpt = document.createElement('option');
    allOpt.value = '';
    allOpt.textContent = 'All Publishers';
    publisherEl.appendChild(allOpt);

    vendors.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      publisherEl.appendChild(opt);
    });
  }

  /* ── Filter + sort ── */
  function applyFilters() {
    filtered = data.filter(function (b) {
      if (activeType !== 'all' && b.type !== activeType) return false;
      if (activeCategory !== 'all' && b.category !== activeCategory) return false;
      if (activeVendor && b.vendor !== activeVendor) return false;
      if (searchVal && b.name.toLowerCase().indexOf(searchVal) === -1) return false;
      return true;
    });

    filtered.sort(function (a, b) {
      if (sortVal === 'az') return a.name.localeCompare(b.name);
      if (sortVal === 'za') return b.name.localeCompare(a.name);
      if (sortVal === 'price-asc') return a.price - b.price;
      if (sortVal === 'price-desc') return b.price - a.price;
      return 0;
    });
  }

  /* ── Render ── */
  function render() {
    gridEl.innerHTML = '';
    updateCount();

    if (filtered.length === 0) {
      emptyEl.style.display = '';
      return;
    }
    emptyEl.style.display = 'none';

    filtered.forEach(function (bundle) {
      gridEl.appendChild(buildCard(bundle));
    });
  }

  function updateCount() {
    var total = data.length;
    var shown = filtered.length;
    if (shown === total) {
      countEl.textContent = total + ' bundle' + (total !== 1 ? 's' : '');
    } else {
      countEl.textContent = shown + ' of ' + total + ' bundle' + (total !== 1 ? 's' : '');
    }
  }

  /* ── Build card ── */
  function buildCard(bundle) {
    var isSet     = bundle.type === 'set';
    var btnLabel  = isSet ? 'Add Set to Cart' : 'Add Bundle to Cart';
    var products  = (bundle.products || []).filter(function (p) { return p && p.variant_id; });
    var publisher = products.length > 0 && products[0].vendor ? products[0].vendor : '';

    /* Pricing math — product prices come from Shopify Liquid as integer cents */
    var bundlePrice   = parseFloat(bundle.price) || 0;
    var originalTotal = 0;
    var savings       = 0;
    if (!isSet && products.length > 0) {
      originalTotal = products.reduce(function (sum, p) {
        var price = parseFloat(p.price);
        if (!isNaN(price) && Number.isInteger(price) && price >= 100) price = price / 100;
        return sum + (isNaN(price) ? 0 : price);
      }, 0);
      savings = originalTotal - bundlePrice;
    }

    var card = document.createElement('div');
    card.className = 'bs-card';

    /* ── Header ── */
    var header = document.createElement('div');
    header.className = 'bs-card__header';

    var headerLeft = document.createElement('div');
    headerLeft.className = 'bs-card__header-left';

    var name = document.createElement('h2');
    name.className = 'bs-card__name';
    name.textContent = bundle.name;
    headerLeft.appendChild(name);

    if (publisher) {
      var pubEl = document.createElement('p');
      pubEl.className = 'bs-card__publisher bs-card__publisher--' + (isSet ? 'set' : 'bundle');
      pubEl.textContent = publisher;
      headerLeft.appendChild(pubEl);
    }

    var typeBadge = document.createElement('span');
    typeBadge.className = 'bs-card__type-badge bs-card__type-badge--' + (bundle.type || 'bundle');
    typeBadge.textContent = isSet ? 'Set' : 'Bundle';

    header.appendChild(headerLeft);
    header.appendChild(typeBadge);
    card.appendChild(header);

    /* ── Body ── */
    var body = document.createElement('div');
    body.className = 'bs-card__body';

    /* Left: cover images + plus signs */
    var left = document.createElement('div');
    left.className = 'bs-card__left';

    if (products.length > 0) {
      products.forEach(function (prod, idx) {
        if (idx > 0) {
          var plus = document.createElement('span');
          plus.className = 'bs-card__plus';
          plus.textContent = '+';
          left.appendChild(plus);
        }

        var item = document.createElement('div');
        item.className = 'bs-card__cover-item';

        var link = document.createElement('a');
        link.href = '/products/' + (prod.handle || '');
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'contents';

        var img = document.createElement('img');
        img.className = 'bs-card__cover-img';
        img.alt = prod.title || '';
        img.loading = 'lazy';
        img.src = prod.image ||
          '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';

        var title = document.createElement('span');
        title.className = 'bs-card__cover-title';
        title.textContent = prod.title || '';

        link.appendChild(img);
        link.appendChild(title);
        item.appendChild(link);
        left.appendChild(item);
      });
    } else {
      var noProds = document.createElement('p');
      noProds.className = 'bs-card__no-products';
      noProds.textContent = 'No products assigned yet.';
      left.appendChild(noProds);
    }

    body.appendChild(left);

    /* Right: description, included items, pricing, ATC */
    var right = document.createElement('div');
    right.className = 'bs-card__right';

    if (bundle.description) {
      var desc = document.createElement('p');
      desc.className = 'bs-card__desc';
      desc.textContent = bundle.description;
      right.appendChild(desc);
    }

    if (products.length > 0) {
      var itemsLabel = document.createElement('p');
      itemsLabel.className = 'bs-card__items-label';
      itemsLabel.textContent = 'Included:';
      right.appendChild(itemsLabel);

      var itemsList = document.createElement('ul');
      itemsList.className = 'bs-card__items-list';
      products.forEach(function (prod) {
        var li = document.createElement('li');
        li.textContent = prod.title || '';
        itemsList.appendChild(li);
      });
      right.appendChild(itemsList);
    }

    /* Pricing row */
    var pricingRow = document.createElement('div');
    pricingRow.className = 'bs-card__pricing-row';

    if (!isSet && originalTotal > 0 && savings > 0.005) {
      var origEl = document.createElement('span');
      origEl.className = 'bs-card__original-price';
      origEl.textContent = formatDollars(originalTotal);
      pricingRow.appendChild(origEl);
    }

    var priceEl = document.createElement('span');
    priceEl.className = 'bs-card__price';
    priceEl.textContent = bundlePrice > 0 ? formatDollars(bundlePrice) : 'Free';
    pricingRow.appendChild(priceEl);

    if (!isSet && savings > 0.005) {
      var savingsEl = document.createElement('span');
      savingsEl.className = 'bs-card__savings';
      savingsEl.textContent = 'Save ' + formatDollars(savings);
      pricingRow.appendChild(savingsEl);
    }

    right.appendChild(pricingRow);

    /* ATC button */
    var atcBtn = document.createElement('button');
    atcBtn.className = 'bs-card__atc bs-card__atc--' + (isSet ? 'set' : 'bundle');
    atcBtn.textContent = btnLabel;
    atcBtn.disabled = products.length === 0;
    atcBtn.addEventListener('click', function () {
      addBundleToCart(bundle, products, atcBtn);
    });
    right.appendChild(atcBtn);

    body.appendChild(right);
    card.appendChild(body);

    return card;
  }

  /* ── Add to cart ── */
  async function addBundleToCart(bundle, products, btn) {
    if (btn.disabled || btn.classList.contains('bs-card__atc--loading')) return;

    var btnLabel = bundle.type === 'set' ? 'Add Set to Cart' : 'Add Bundle to Cart';

    var items = products
      .filter(function (p) { return p.available && p.variant_id; })
      .map(function (p) {
        return {
          id: p.variant_id,
          quantity: 1,
          properties: { '_bundle': bundle.name }
        };
      });

    if (items.length === 0) {
      alert('No available products in this bundle.');
      return;
    }

    /* Loading state */
    btn.disabled = true;
    btn.classList.add('bs-card__atc--loading');
    btn.textContent = 'Adding…';

    try {
      var cartDrawer = document.querySelector('cart-drawer');
      var sectionsToRender = (cartDrawer && cartDrawer.getSectionsToRender)
        ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];

      console.log('[BS] ATC: posting ' + items.length + ' item(s), sections=' + JSON.stringify(sectionsToRender));

      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      var responseBody = await r.json().catch(function (e) {
        console.error('[BS] ATC: failed to parse response JSON', e);
        return null;
      });

      console.log('[BS] ATC: /cart/add.js status=' + r.status + ' ok=' + r.ok);
      console.log('[BS] ATC: responseBody.sections=' + (responseBody && responseBody.sections ? JSON.stringify(Object.keys(responseBody.sections)) : 'missing'));

      if (!r.ok) {
        throw new Error((responseBody && responseBody.description) || ('Cart error ' + r.status));
      }

      if (cartDrawer && responseBody && responseBody.sections) {
        var parser = new DOMParser();

        /* Update #CartDrawer innerHTML */
        var drawerSectionHtml = responseBody.sections['cart-drawer'];
        if (drawerSectionHtml) {
          var drawerDoc    = parser.parseFromString(drawerSectionHtml, 'text/html');
          var drawerSource = drawerDoc.querySelector('#CartDrawer');
          var drawerTarget = document.querySelector('#CartDrawer');
          if (drawerTarget && drawerSource) {
            drawerTarget.innerHTML = drawerSource.innerHTML;
            console.log('[BS] ATC: #CartDrawer updated');
          }
        }

        /* Update cart-icon-bubble */
        var bubbleSectionHtml = responseBody.sections['cart-icon-bubble'];
        if (bubbleSectionHtml) {
          var bubbleDoc    = parser.parseFromString(bubbleSectionHtml, 'text/html');
          var bubbleSource = bubbleDoc.querySelector('.shopify-section');
          var bubbleTarget = document.getElementById('cart-icon-bubble');
          if (bubbleTarget && bubbleSource) {
            bubbleTarget.innerHTML = bubbleSource.innerHTML;
            console.log('[BS] ATC: cart-icon-bubble updated');
          }
        }

        /* Remove is-empty so drawer shows items */
        var drawerInner = cartDrawer.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
        cartDrawer.classList.remove('is-empty');

        /* Open the drawer — trapFocus can throw on non-product pages */
        try {
          cartDrawer.open();
        } catch (openErr) {
          console.warn('[BS] ATC: cartDrawer.open() threw (likely trapFocus):', openErr);
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      } else {
        console.warn('[BS] ATC: no sections in response — opening drawer without DOM update');
        if (cartDrawer) {
          try { cartDrawer.open(); } catch (e) {
            cartDrawer.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }
      }

      /* Publish cartUpdate so CartDrawerItems and other subscribers stay in sync */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      }

      console.log('[BS] ATC: done');
      btn.disabled = false;
      btn.classList.remove('bs-card__atc--loading');
      btn.classList.add('bs-card__atc--done');
      btn.textContent = 'Added to Cart!';

      setTimeout(function () {
        btn.classList.remove('bs-card__atc--done');
        btn.textContent = btnLabel;
      }, 3000);

    } catch (err) {
      console.error('[BS] cart error:', err);
      alert('Could not add to cart. Please try again.');
      btn.disabled = false;
      btn.classList.remove('bs-card__atc--loading');
      btn.textContent = btnLabel;
    }
  }

  /* ── Helpers ── */
  function formatDollars(amount) {
    var num = parseFloat(amount);
    if (isNaN(num)) return '$0.00';
    return '$' + num.toFixed(2);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
